// Loading button enhancer
// Loading button adds a spinner icon to the button and disables it when it is clicked.
// Call $("#button-id").trigger("loadingButton.reset") to restore the button state
(($) => {
    "use strict";

    $.enhancer("loadingButton",
        {
            button: null,
            buttonText: null,
            triggerDefault: false,
            form: null,
            init: function (el) {

                this.button = $(el);
                this.buttonText = this.button.children(".btn-text");
                this.form = this.button.closest('form');

                this.button.on("loadingButton.setLoading", $.proxy(this.setLoadingState, this))
                    .on("loadingButton.reset", $.proxy(this.reset, this));

                if (this.button.data("trigger-onclick")) {
                    this.button.on("click", $.proxy(this.setLoadingState, this));
                }

                if (this.button.data("trigger-default")) {
                    this.triggerDefault = true;
                }

                // Hook into the validation invalidHandler to reset the loading state if the form is invalid
                var validator = this.form.data('validator');
                if (validator) {
                    var thisButton = this.button;
                    this.form.on('invalid-form',
                        function () {
                            thisButton.trigger("loadingButton.reset");
                        });
                }

            },
            setLoadingState: function () {

                const button = this.button,
                    buttonText = this.buttonText;

                button.addClass("btn-loading loading-animation-active");

                if (button.data("loading-text")) {
                    button.data("default-text", buttonText.text());

                    buttonText.text(button.data("loading-text"));
                }

                setTimeout(() => { button.prop("disabled", true); }, 1);

                return this.triggerDefault;
            },
            reset: function (btn) {
                this.button.removeClass("btn-loading");

                var thisButton = this.button;
                setTimeout(() => { thisButton.prop("disabled", false); }, 1);

                if (this.button.data("default-text")) {
                    this.buttonText.text(this.button.data("default-text"));
                }
            }
        });

})(jQuery);